<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <ejs-dropdownbutton :items='adduser' iconCss='icon hero-icon hero-icon-batch-add' :select='dropDownAddUser'></ejs-dropdownbutton>
        <ejs-dropdownbutton :items='moduser' iconCss='icon hero-icon hero-icon-batch-edit' :select='dropDownModUser'></ejs-dropdownbutton>
        <div v-if='btns.del'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" :title="$t('SubscriberIms.del')" @click='buttonClk("del")'/>-->
          <button :title='$t("SubscriberIms.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("del")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
          </button>
        </div>
        <div v-if='btns.refresh'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-refresh" :title="$t('SubscriberIms.fresh')" @click='buttonClk("refresh")'/>-->
          <button :title='$t("SubscriberIms.fresh")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("refresh")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-refresh e-icons"></span>
          </button>
        </div>
        <ejs-dropdownbutton :items='userMember' iconCss='icon hero-icon hero-icon-groupmember' :select='dropDownUserMember'></ejs-dropdownbutton>
        <div v-if='btns.import'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-excel-import" :title="$t('SubscriberIms.import')" @click='buttonClk("import")'/>-->
          <button :title='$t("SubscriberIms.import")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("import")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-import e-icons"></span>
          </button>
        </div>
        <div v-if='btns.export'>
          <!--<download-excel :fetch="fetchData" :fields="json_fields" :before-generate="startDownload" :before-finish="finishDownload" worksheet="impu" :name="fileName">-->
            <!--<div class="btn e-tbar-btn icon hero-icon hero-icon-excel-export"></div>-->
          <!--</download-excel>-->
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-excel-export" :title="$t('SubscriberIms.export')" @click='buttonClk("export")'/>-->
          <button :title='$t("SubscriberIms.export")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("export")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-export e-icons"></span>
          </button>
        </div>

        <div class="e-toolbar-item e-separator" aria-disabled="false"></div>
        <div v-if='btns.qry'>
          <!--<button class="e-btn e-tbar-btn icon hero-icon hero-icon-search" :title="$t('SubscriberIms.search')" @click='buttonClk("search")'/>-->
          <button :title='$t("SubscriberIms.search")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("search")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-search e-icons"></span>
          </button>
        </div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
import Vue from 'vue';
import JsonExcel from 'vue-json-excel';

Vue.component('downloadExcel', JsonExcel);
export default {
  name: 'UserTableMenu',
  data() {
    return {
      components: {

      },
      fileName: `impu${new Date().getTime()}.xls`,
      json_fields: {
        USERNAME: 'username', // 设备组名称
        RTTTYPE: 'rtttype',
        INVALIDTIME: 'invalidtime',
        USERENABLE: 'userenable',
        IMPU: 'impu',
        VPNID: 'vpnid',
        SUBNAME: 'subname',
        SUBSTATUS: 'substatus',
        EMERGENCYNUM: 'emergencynum',
        EMERGENCYGRPNUM: 'emergencygrpnum',
        EMERGENCYALARMNUM: 'emergencyAlarmNum',
        CALLPRIORITY: 'callpriority',
        REGCLASS0: 'regclass0',
        REGCLASS1: 'regclass1',

        VOICECLASS0: 'voiceclass0',
        VOICECLASS1: 'voiceclass1',
        VOICECLASS2: 'voiceclass2',
        OTHERCLASS0: 'otherclass0',
        OTHERCLASS1: 'otherclass1',
        OTHERCLASS10: 'otherclass10',
        OTHERCLASS13: 'otherclass13',
        OTHERCLASS14: 'otherclass14',
        OTHERCLASS19: 'otherclass19',

        DATACLASS0: 'dataclass0',
        DATACLASS1: 'dataclass1',
        DATACLASS2: 'dataclass2',
        DATACLASS3: 'dataclass3',

        MEDIACLASS0: 'mediaclass0',
        MEDIACLASS1: 'mediaclass1',
        MEDIACLASS2: 'mediaclass2',
        MEDIACLASS3: 'mediaclass3',
        MEDIACLASS4: 'mediaclass4',
        MEDIACLASS5: 'mediaclass5',
        MEDIACLASS6: 'mediaclass6',
        MEDIACLASS7: 'mediaclass7',
        MEDIACLASS8: 'mediaclass8',
        MEDIACLASS9: 'mediaclass9',
        MEDIACLASS10: 'mediaclass10',
        MEDIACLASS11: 'mediaclass11',
        OTHERCLASS15: 'otherclass15',
        OTHERCLASS20: 'otherclass20',
        DATACLASS4: 'dataclass4',
        DATACLASS5: 'dataclass5',

        OTHERCLASS2: 'otherclass2',
        OTHERCLASS3: 'otherclass3',
        OTHERCLASS5: 'otherclass5',
        OTHERCLASS6: 'otherclass6',
        OTHERCLASS7: 'otherclass7',
        OTHERCLASS8: 'otherclass8',
        OTHERCLASS9: 'otherclass9',
        OTHERCLASS11: 'otherclass11',
        OTHERCLASS12: 'otherclass12',
        OTHERCLASS16: 'otherclass16',
        OTHERCLASS17: 'otherclass17',
        OTHERCLASS18: 'otherclass18',
        OTHERCLASS21: 'otherclass21',
        OTHERCLASS22: 'otherclass22',
        OTHERCLASS23: 'otherclass23',
        OTHERCLASS24: 'otherclass24',

        IMPI: 'impi',
        HTCFADDR: 'htcfaddr',
        LTEIMSI: 'lteimsi',
        REALM: 'realm',
        PASSWORD: 'password',
        REGSTATUS: 'regstatus',
        FOAOROACSU: 'foaoroacsu',
      },
      btns: {
        add: true,
        mod: true,
        del: true,
        refresh:true,
        userMember: true,
        qry: true,
        import: true,
        export: true
      },
      userMember: [
        {
          text: this.$t('SubscriberIms.addGroupMember'),
          value: 0
        },
        {
          text: this.$t('SubscriberIms.qryGroupMember'),
          value: 1
        }],
      adduser: [
        {
          text: this.$t('SubscriberIms.addUser'),
          value: 0
        },
        {
          text: this.$t('SubscriberIms.batchAddUser'),
          value: 1
        }],
      moduser: [
        {
          text: this.$t('SubscriberIms.modUser'),
          value: 0
        },
        {
          text: this.$t('SubscriberIms.batchModUser'),
          value: 1
        }]
    };
  },
  methods: {
    async fetchData() {
      const formParam = this.$parent.$parent.$refs.usertable.$refs.qryImsUser.getFormValue();
      const conditionParams = { neid: this.$parent.$parent.$refs.usertable.info.neid, impu: formParam.impu, username: formParam.username, userenable: formParam.userenable, rtttype: formParam.rtttype, vpnid: this.$parent.$parent.$refs.usertable.info.vpnid, vpnClass: this.$parent.$parent.$refs.usertable.info.vpnClass };
      const params = {
        operation: 'impu',
        vo: conditionParams,
      };
      const arr = [];
      await this.$axios.post('/lte/ems/subscriber/imsunms/exportData', params).then((response) => {
        console.log(response);
        if (typeof (response) === 'undefined') {
          this.$layer.alert({ msg: '请求失败' });
        } else {
          for (let i = 0; i < response.data.length; i++) {
            arr.push(response.data[i]);
          }
        }
      });

      return arr;
    },
    startDownload() {
      // alert('show loading');
    },
    finishDownload() {
      // alert('hide loading');
    },
    buttonClk(args) {
      this.$emit('methodEnum', args);
    },
    dropDownUserMember(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'addUserMember');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'qryUserMember');
      }
    },
    dropDownAddUser(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'add');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'batchAdd');
      }
    },
    dropDownModUser(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'mod');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'batchMod');
      }
    },
  }
};
</script>

<style scoped>

</style>
